import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
import { Address } from "./addresses/Address";
export class Company extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * Legal name of the organization (optional)
         */
        this.name = '';
        this.VATNumber = null;
        this.companyNumber = null;
        this.address = null;
        this.administrationEmail = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, optional: true, defaultValue: () => uuidv4() })
], Company.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Company.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], Company.prototype, "VATNumber", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], Company.prototype, "companyNumber", void 0);
__decorate([
    field({ decoder: Address, nullable: true })
], Company.prototype, "address", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, optional: true })
], Company.prototype, "administrationEmail", void 0);
//# sourceMappingURL=Company.js.map